.list {
  display: grid;
  gap: var(--sp-10);
  max-width: 52rem;
}
